export default __webpack_public_path__ + "static/media/avantages-membres-candidats.13f1162c.jpg";